import {Globals} from "./";
import isMobile from 'ismobilejs';

class Utils{

    static callAPIMethod(methodName,params){
        
        if (!methodName){
            return Promise.reject("Invalid method name");
        }


        let API_URL=Globals.BASE_PATH+"/api/"+methodName+"/";

        if (!params) params={};
        let fd=new FormData();
        for (let key in params){
            fd.append(key,params[key]);
        }

        let p=new Promise((resolve,reject)=>{
            fetch(API_URL,{
                method: 'POST',
                cache: 'no-cache',
                body: fd
            })
            .then((response)=>{
                if (response && response.status===200){
                    return response.json();
                }else{
                    reject("Invalid status code");
                }
            })
            .then((json)=>{
                if (json && json.success){
                    resolve(json);
                }else if (json && json.errMsg){
                    reject(json.errMsg);
                }else{
                    reject('Unknown error');
                }
            })
            .catch((e)=>{
                reject("Unknown error");
            });
        })
        return p;
    }

    static getSlug(url){
        let ret=url;
        let ind=ret.indexOf(Globals.BASE_PATH);
        if (ind>=0){
            ret=ret.substr(Globals.BASE_PATH.length);
        }
        while (ret.length && ret[0]=='/') ret=ret.substr(1);
        return ret;
        //return url;
    }

    static mapNumber(val,min,max,newMin,newMax){
        let pc=(val-min)/(max-min);
        return newMin+(newMax-newMin)*pc;
    }

    static live(eventType, elementQuerySelector, cb) {
        document.addEventListener(eventType, function (event) {
            var qs = document.querySelectorAll(elementQuerySelector);

            if (qs) {
                var el = event.target, index = -1;
                while (el && ((index = Array.prototype.indexOf.call(qs, el)) === -1)) {
                    el = el.parentElement;
                }

                if (index > -1) {
                    cb.call(el, event);
                }
            }
        });
    }

    static splitToElems(text,sep,prev,next){
        let ret='';
        let arr=text.split(sep);
        for (let i=0;i<arr.length;i++){
            ret+=prev
            ret+=arr[i];
            ret+=next;
        }
        return ret;
    }

    static debounce(func,wait,immediate=false){
        let timeout;

        return function () {
            const context = this, args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };

            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    static getFileExtension(fileName) {
        if (fileName.indexOf("?")>=0){
            fileName=fileName.substr(0,fileName.indexOf("?"));
        }
        let extension = fileName.substr((fileName.lastIndexOf('.') + 1)).toLowerCase();
        return extension;
    }

    static isMobileResolution(){
        const w=window.innerWidth;
        return w<768;
    }

    static isTabletResolution(){
        const w=window.innerWidth;
        return w<1024;
    }

    static isDeviceResolution(){
        return this.isMobileResolution() || this.isTabletResolution();
    }

    static isMobile(){
        const ua=navigator.userAgent;
        return isMobile(ua).phone;
        /*const w=window.innerWidth;
        return w<1024;*/
    }

    static isTablet(){
        const ua=navigator.userAgent;
        return isMobile(ua).tablet;
        return false;
    }

    static isDevice(){
        return this.isMobile() || this.isTablet();
    }

    static logDevice(){
        const ua=navigator.userAgent;
    }

    static compareObjects(obj1, obj2){
        const keys1=Object.keys(obj1);
        const keys2=Object.keys(obj2);

        if (keys1.length!=keys2.length) return false;
        for (let key of keys1){
            if (obj1[key]!==obj2[key]){
                return false;
           }
        }
        return true;
    }

    static isValidEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

}

export {Utils}